/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import { List } from "@mui/material";
import { EditOutlined, LogoutOutlined } from "@ant-design/icons";
import { useAuth } from "cms/auth/hooks/use-auth";
import { NavLink } from "react-router-dom";
import { MenuItemCard } from "./MenuItemCard";

const ProfileTab = () => {

    const [selectedIndex, setSelectedIndex] = useState(0);
    const { logout } = useAuth();
    
    const handleLogout = async () => {
        logout();
    }
    
    const handleProfileClick = (index) => {
        setSelectedIndex(index);
    }

    return (
        <List
            component='nav'
            style={{ padding: 0 }}
            // style={{ padding: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}
        >

            <MenuItemCard
                primary='Profile'
                icon={<EditOutlined />}
                index={0}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                onClick={handleProfileClick}
                component={NavLink}
                to='/profile'
            />

            <MenuItemCard
                primary='Logout'
                icon={<LogoutOutlined />}
                index={1}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                onClick={handleLogout}
            />


            {/*<ListItemButton*/}
            {/*    selected={selectedIndex === 0}*/}
            {/*    onClick={() => {}}*/}
            {/*    component={NavLink}*/}
            {/*    to='/settings/profile'*/}
            {/*>*/}
            {/*    <ListItemIcon>*/}
            {/*        <EditOutlined />*/}
            {/*    </ListItemIcon>*/}
            {/*    <ListItemText primary='Profile' />*/}
            {/*</ListItemButton>*/}

            {/*<ListItemButton selected={selectedIndex === 1} onClick={handleLogout}>*/}
            {/*    <ListItemIcon>*/}
            {/*        <LogoutOutlined />*/}
            {/*    </ListItemIcon>*/}
            {/*    <ListItemText primary='Logout' />*/}
            {/*</ListItemButton>*/}
        </List>
    );
};

ProfileTab.propTypes = {
    handleLogout: PropTypes.func,
};

export { ProfileTab };
